<script lang="ts">
export default {
  name: "EventPage",
};
</script>
<script setup lang="ts">
import LeftEvent from "./components/left-event.vue"
import RightEvent from "./components/right-event.vue"
import { useVueCesium } from 'vue-cesium'
import type { VcViewerProvider, VcReadyObject } from 'vue-cesium/es/utils/types'
import { flyToCamera } from 'vue-cesium/es/utils/cesium-helpers'

const $vc: VcViewerProvider = useVueCesium()

onMounted(() => {
  // $vc.creatingPromise.then((readyObj: VcReadyObject) => {
  //    flyToCamera(
  //     $vc.viewer,
  //     {
  //       position: Cesium.Cartesian3.fromDegrees(119.840, 31.010, 1000),
  //       heading: 6.283185307179586,
  //       pitch: -0.5001412827126326,
  //       roll: 6.283185307179586
  //     },
  //   )
  // })
})
</script>

<template>
  <div class="event-page pointer-page">
    <left-event />
    <right-event />
  </div>
</template>

<style scoped lang="scss">
.event-page{
  width: 100vw;
  height: 100vh;
  position: relative;
  z-index: 1;
  pointer-events: none;
}
</style>
